import { Spinner } from '../../../components/Common-components/spinner'
import { useUserReport } from '../hook/useUserReport'
import { UserReportFilters } from '../component/userReportFilters'
import { Area, Bar, CartesianGrid, ComposedChart, Tooltip, XAxis, YAxis } from 'recharts'

export const GrowthTrendsUsers = () => {
    const { data, methods } = useUserReport()
    const { details, loader, filterInputs } = data

    const chartData = [
        {
            name: `Previous ${filterInputs?.filter?.name}`,
            Count: details?.previousPeriodCount ?? 0,
        },
        {
            name: `Current ${filterInputs?.filter?.name}`,
            Count: details?.currentPeriodCount ?? 0,
        },
    ]
    return (
        <>
            {loader && <Spinner />}
            <section className="filter">
                <UserReportFilters data={data} methods={methods} />
            </section>
            <section className="mt-3 d-flex justify-content-center  align-items-center" style={{ height: '500px' }}>
                {details ? (
                    <div className="w-100 d-flex justify-content-center h-100 align-items-center">
                        <ComposedChart width={730} height={250} data={chartData}>
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <CartesianGrid stroke="#f5f5f5" />
                            <Area type="monotone" dataKey="Count" fill="#8884d8" stroke="#8884d8" />
                            <Bar dataKey="Count" barSize={20} fill="#413ea0" />
                        </ComposedChart>
                    </div>
                ) : (
                    <div className="text-muted py-5">No data to display</div>
                )}
            </section>
        </>
    )
}
